import Searchsalesbyaccredited from './components/searchsalesbyaccredited/searchsalesbyaccredited.vue'
import BoardSaledReportsAccredited from './components/boardsalesreportsaccredited/boardsalesreportsaccredited.vue'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import TableSalesAccredtitedMonth from './components/tablesalesaccreditedmonth/tablesalesaccreditedmonth.vue'
import TableSalesReportsAccredited from './components/tablesalesreportsaccredited/tablesalesreportsaccredited.vue'
import ProposalRepository from '@/shared/http/repositories/realestate/proposal'
import { loading } from '@/shared/utils/UIHelper'
import Roles from '@/shared/utils/roles'
import PermisionMixin from '@/store/module/permission/mixin'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  components: {Searchsalesbyaccredited, BoardSaledReportsAccredited, TableSalesReportsAccredited, TableSalesAccredtitedMonth},
  name: 'Salesbyaccredited',
  data () {
    return {
      meses: ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'],
      haveData: true,
      dataEnteprise: [],
      roles: Roles,
      dataCredenciada: [],
      dataEntepriseSearch: [],
      columns: ['VENDAS', 'VALOR', 'QUANTIITEM'],
      filterWeek: false,
      filtroExistente: null,
      allSales: [],
      reportEnterprise: [],
      customDate: false,
      onlyTable: false,
      containerBoards: 0,
      hasData: false,
      containerImgReportClass: 'container-img-reports invisible',
      currentyMonth: new Date().getMonth()
    }
  },
  mixins: [ PermisionMixin ],
  mounted () {
    const now = new Date()
    const firstDay = new Date(now.getFullYear(), 0, 1)
    const lastDay = new Date(now.getFullYear(), 11, 31)
    if (localStoreHelper.relatorio.vendasCredenciadas() != null) {
      this.filtroExistente = localStoreHelper.relatorio.vendasCredenciadas()
    }
    if (this.filtroExistente !== null) {
      this.setSearch(true)
      this.search()
    } else {
      let objSearch = {
        DtFinal: lastDay,
        DtInicial: firstDay
      }
      ProposalRepository.GetRelatorioCredenciada(objSearch)
        .then(Response => {
          this.hasData = (Response.data.data.length > 0)
          localStoreHelper.relatorio.vendasCredenciadas(null)
          if (!this.hasData) {
            this.containerImgReportClass = this.containerImgReportClass.replace('invisible', '')
          } else {
            if (!this.containerImgReportClass.includes('invisible', '')) {
              this.containerImgReportClass = this.containerImgReportClass + ' invisible'
            }
          }
          this.allSales = Response.data.data
        })
    }
  },
  methods: {
    filterByMonth (month) {
      return this.allSales.filter(report => report.mes === month)
    },
    setSearch (newValue) {
      this.onlyTable = newValue
    },
    setCustomDate (newValue) {
      this.customDate = newValue
    },
    search (objSearch) {
      this.reportEnterprise = []
      this.containerBoards++
      loading.push()
      ProposalRepository.GetRelatorioCredenciada(objSearch == null || objSearch === undefined ? this.filtroExistente : objSearch)
        .then(Response => {
          this.hasData = (Response.data.data.length > 0)
          if (!this.hasData) {
            this.containerImgReportClass = this.containerImgReportClass.replace('invisible', '')
          } else {
            if (!this.containerImgReportClass.includes('invisible', '')) {
              this.containerImgReportClass = this.containerImgReportClass + ' invisible'
            }
          }
          loading.pop()
          if (this.onlyTable) {
            let dataSales = Response.data.data
            let enterpriseNames = []
            dataSales.forEach(sale => {
              if (!enterpriseNames.includes(sale.nomeEmpreendimento)) {
                enterpriseNames.push(sale.nomeEmpreendimento)
              }
            })
            enterpriseNames.forEach(enterpriseName => {
              this.reportEnterprise.push(
                dataSales.filter(sale => sale.nomeEmpreendimento === enterpriseName)
              )
            })
            return
          }
          this.allSales = Response.data.data
        })
    },
    getDataSales (posicaoMes) {
      this.$refs.BoardSale[posicaoMes].SetDataSales(this.filterByMonth(posicaoMes))
    },
    getAllEnterprise () {
      loading.push()
      EnterpriseRepository.GetAllRelatorio()
        .then(Response => {
          loading.pop()
          this.dataEnteprise = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    getAllCredenciada () {
      loading.push()
      ProposalRepository.GetAll()
        .then(Response => {
          loading.pop()
          this.dataCredenciada = Response.data.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    getAllCredenciadaSearchrela (obj = {}) {
      this.search = obj
      if (obj !== {}) {
        this.filterWeek = obj.filterweek
      }
      loading.push()
      ProposalRepository.getAllCredenciadaSearchrela(obj)
        .then(Response => {
          loading.pop()
          this.dataCredenciada = Response.data.data
          this.getAllEnterprisearch(this.search)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    getAllEnterprisearch (obj) {
      loading.push()
      EnterpriseRepository.GetAllRelatorioSearch(obj)
        .then(Response => {
          this.dataEnteprise = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesbyaccredited/salesbyaccredited.js